import { Applicant } from '@/components/pages/Applicant/Applicant.types';
import { ProductNames } from '@/components/providers/ApplicantContextProvider/ApplicantContextProvider.types';
import { getProductLabel } from '../../../ApplicantConditions/ApplicantConditions.utils';

export type PlaceholderValues = Readonly<Record<string, string>>;

const PLACEHOLDER_PATTERN = /\[\[([A-Z_]+)\]\]/g;

// Mirrors the backend's NmiTemplateService placeholder set; the send endpoints mail notes verbatim, so tokens must be filled here.
export const buildPlaceholderValues = (
    applicant: Applicant | undefined,
    products: ReadonlyArray<string>,
): PlaceholderValues => {
    const owner = applicant?.owners?.[0];
    const business = applicant?.businessInfo;
    return {
        FIRST_NAME: owner?.legalFirstName?.trim() ?? '',
        LAST_NAME: owner?.legalLastName?.trim() ?? '',
        COMPANY_NAME: business?.legalName?.trim() || business?.dbaName?.trim() || '',
        PRODUCT: products.map((p) => getProductLabel(p as ProductNames)).join(' and '),
    };
};

// Unknown tokens are left in place so the reviewer sees them in the message box before sending.
export const renderPlaceholders = (text: string, values: PlaceholderValues): string =>
    text.replace(PLACEHOLDER_PATTERN, (token, name: string) => values[name] ?? token);
